<template>
    <div class="questionnaire-auth">
        <AuthForm
            :registration-errors="errors"
            :registration-disabled="fetchingNewCustomerSubmit"
            back-button-in-title
            @login="handleLoginSuccess"
            @register="submitNewCustomer"
        >
            <template #registration-title>
                {{ signUpStep.title }}
            </template>

            <template
                v-if="signUpStep.description"
                #registration-description
            >
                {{ signUpStep.description }}
            </template>

            <template
                v-if="signUpStep.submitButtonLabel"
                #registration-submit
            >
                {{ signUpStep.submitButtonLabel }}
            </template>
        </AuthForm>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useCustomerRegistrationInputStore } from '@/composables/useCustomerRegistrationInput'
import type { QuestionnaireSignUpStepFragment } from '@/graphql/api'
import type { ErrorCollectionWithTraces } from '@/helpers/errors'

import AuthForm from '@/components/user/auth/AuthForm.vue'

defineProps<{
    fetchingNewCustomerSubmit: boolean
    errors: ErrorCollectionWithTraces
    signUpStep: QuestionnaireSignUpStepFragment
}>()

const emits = defineEmits<{
    'login-success': []
    'submit-new-customer': [successCallback: () => void]
}>()

const { customerRegistrationInput } = storeToRefs(
    useCustomerRegistrationInputStore()
)

const handleLoginSuccess = () => {
    emits('login-success')
}

const submitNewCustomer = async (successCallback: () => void) => {
    const customer = customerRegistrationInput.value

    if (!customer) {
        return
    }

    emits('submit-new-customer', successCallback)
}
</script>

<style lang="scss" scoped>
.questionnaire-auth {
    position: relative;
    width: 100%;
    min-height: 92vh;
    max-width: 380px;

    .registration-form,
    .login-form {
        :deep(.signin-switch) {
            bottom: 100px;
        }
    }
}
</style>
